import React from "react";

type CardOption = {
  value: string | number;
  title: string;
  description: string;
  disabled?: boolean;
  comingSoon?: boolean;
};

type CardSelectionProps = {
  label?: string;
  subtitle?: string;
  options: CardOption[];
  value?: string | number;
  onChange: (value: string | number) => void;
  className?: string;
};

export default function CardSelection({
  label,
  subtitle,
  options,
  value,
  onChange,
  className = "",
}: CardSelectionProps) {
  return (
    <div className={`flex flex-col gap-4 w-full ${className}`}>
      {/* Header */}
      {label && (
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-semibold text-black">{label}</h2>
          {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        </div>
      )}

      {/* Cards */}
      <div className="flex flex-col gap-2">
        {options.map((option) => {
          const isSelected = value === option.value;
          const isDisabled = option.disabled || option.comingSoon;

          return (
            <div
              key={option.value}
              onClick={() => !isDisabled && onChange(option.value)}
              className={`
                relative
                flex flex-row items-start gap-4
                p-3
                border-2
                rounded-xl
                transition-all
                ${
                  isDisabled
                    ? "cursor-not-allowed opacity-60 bg-gray-50"
                    : "cursor-pointer "
                }
                ${
                  isSelected
                    ? "border-black bg-gray-50"
                    : "border-gray-200 bg-white"
                }
              `}
            >
              {/* Content */}
              <div className="flex-1 flex flex-col gap-1">
                <h3 className="text-h2 font-medium text-black">
                  {option.title}
                </h3>
                <p className="text-h3 text-gray-600 ">
                  {option.description}
                  {option.comingSoon && (
                    <span className="text-gray-400"> (Coming soon)</span>
                  )}
                </p>
              </div>

              {/* Radio button */}
              <div className="flex-shrink-0 mt-1">
                <div
                  className={`
                    w-4 h-4
                    rounded-full
                    border-2
                    transition-all
                    flex items-center justify-center
                    ${
                      isSelected
                        ? "border-black bg-black"
                        : "border-gray-300 bg-white"
                    }
                    ${isDisabled ? "opacity-50" : ""}
                  `}
                >
                  {isSelected && (
                    <div className="w-2 h-2 rounded-full bg-white" />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
